import { CatchErrorMessageMixin } from '@ultraware/vee-form-handler'
import { Component, Mixins } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class NotifyMixin extends Mixins(CatchErrorMessageMixin) {
  public autoBindLastXhrErrorResponse = false
  public showMessage(type: string, message: string, timeout: number = 10000): void {
    this.$q.notify({
      message,
      timeout,
      color: type,
      icon: this.getIcon(type),
      position: 'top',
      actions: [{ icon: 'close', color: 'white' }],
    })
  }

  private getIcon(type: string): string {
    switch (type) {
      case 'positive':
        return 'check_circle'
      case 'negative':
        return 'warning'
      case 'warning':
        return 'priority_high'
      case 'info':
      default:
        return 'info'
    }
  }
}
